import React from "react";

import useLoadViewableShares from "../../graphql/hooks/useLoadViewableShares";
import MentionMenu from "./MentionMenu";

interface MentionMenuCallProps {
  inputRef: React.MutableRefObject<HTMLElement | null>;
  callId: string;
  clipId?: string | null;
}

const MentionMenuCall: React.FC<MentionMenuCallProps> = ({
  inputRef,
  callId,
  clipId,
}) => {
  const { callOrClip, loading } = useLoadViewableShares({ callId, clipId });

  return (
    <MentionMenu
      inputRef={inputRef}
      loading={loading}
      shareableUsers={callOrClip?.shareableUsers}
    />
  );
};

export default MentionMenuCall;
